'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _actions = require('./actions');

var viActions = _interopRequireWildcard(_actions);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _middleware = require('./migration/middleware');

var _middleware2 = _interopRequireDefault(_middleware);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;

var _storeInstance = { initialized: false };
var _timeSubscriberQueue = {};
var _playerInstances = {};
var NO_PLAYER_READY = 'NO_PLAYER_READY';
var FIRST_PLAYER = 'FIRST_PLAYER';

/**
 * Sets the local store instance for VI
 *
 * @param {Object} instance - A redux store instance
*/
function setStoreInstance(instance) {
  _storeInstance = instance;
}

/**
 * Creates and setups a default redux store for VI
 *
 * @returns {Object} store - An instance of a redux store
 */
function createReduxStore() {
  var propReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var propMiddleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!_storeInstance.hasOwnProperty('initialized')) {
    return _storeInstance;
  }

  var middlewares = [_reduxThunk2.default, _middleware2.default].concat(propMiddleware);
  var reducers = _extends({}, _reducers2.default, propReducers);

  var store = (0, _redux.createStore)((0, _redux.combineReducers)(reducers), composeEnhancers(_redux.applyMiddleware.apply(null, middlewares)));

  setStoreInstance(store);
  return store;
}

/**
 * Holds a Video Playback player instance against a specific id, and if there are TimeSubscribers
 * queued, then set them up against that player
 *
 * @param {string} playerId - The id to store the player against
 * @param {Object} instance - The player instance to store
 */
function addPlayerInstance(playerId, instance) {
  _playerInstances[playerId] = instance;
  if (_timeSubscriberQueue[NO_PLAYER_READY]) {
    if (_timeSubscriberQueue[NO_PLAYER_READY][playerId] || _timeSubscriberQueue[NO_PLAYER_READY][FIRST_PLAYER]) {
      var associatedObject = _timeSubscriberQueue[NO_PLAYER_READY][playerId] || [];
      if (_timeSubscriberQueue[NO_PLAYER_READY][FIRST_PLAYER]) {
        associatedObject = associatedObject.concat(_timeSubscriberQueue[NO_PLAYER_READY][FIRST_PLAYER]);
      }

      for (var i = 0; i < associatedObject.length; i++) {
        associatedObject[i](playerId, instance);
      }

      delete _timeSubscriberQueue[NO_PLAYER_READY][playerId];
      if (_timeSubscriberQueue[NO_PLAYER_READY][FIRST_PLAYER]) {
        delete _timeSubscriberQueue[NO_PLAYER_READY][playerId];
      }
      if (!Object.keys(_timeSubscriberQueue[NO_PLAYER_READY]).length) {
        delete _timeSubscriberQueue[NO_PLAYER_READY];
      }
    }
  }
  if (_timeSubscriberQueue[playerId]) {
    for (var _i = 0; _i < _timeSubscriberQueue[playerId].length; _i++) {
      _timeSubscriberQueue[playerId][_i](playerId, instance);
    }
  }
}

/**
 * Removes a Video Playback instance from our stores playerInstances collection.
 *
 * @param {string} playerId - The id of the player to destroy
 */
function removePlayerInstance(playerId) {
  delete _playerInstances[playerId];
}

/**
 * Retrieves a player instance from the stored collection, based on the Id provided
 *
 * @param {Number} id - The id of the player to retrieve
 * @returns {Object} - The player instance
 */
function getPlayerInstance(id) {
  return _playerInstances[id];
}

/**
 * Queues TimeSubscriber setup functions against a specific player
 * @param {Number} playerId - The playerId to associate a setup function with
 * @param {Function} setupFunc - The function to be executed
 */
function queueTimeComponent(playerId, setupFunc) {
  var selectedPlayerId = playerId;
  if (!selectedPlayerId) {
    if (Object.keys(_playerInstances).length > 0) {
      selectedPlayerId = Object.keys(_playerInstances)[0];
    } else {
      selectedPlayerId = FIRST_PLAYER;
    }
  }
  if (!_playerInstances[selectedPlayerId]) {
    if (!_timeSubscriberQueue[NO_PLAYER_READY]) {
      _timeSubscriberQueue[NO_PLAYER_READY] = {};
    }
    if (!_timeSubscriberQueue[NO_PLAYER_READY][selectedPlayerId]) {
      _timeSubscriberQueue[NO_PLAYER_READY][selectedPlayerId] = [];
    }
    _timeSubscriberQueue[NO_PLAYER_READY][selectedPlayerId].push(setupFunc);
    return;
  }
  if (_playerInstances[selectedPlayerId]) {
    setupFunc(selectedPlayerId, _playerInstances[selectedPlayerId]);
    return;
  }
  if (!_timeSubscriberQueue[selectedPlayerId]) {
    _timeSubscriberQueue[selectedPlayerId] = [];
  }
  _timeSubscriberQueue[selectedPlayerId].push(setupFunc);
}

/**
 * Removes TimeSubscriber setup function from the queue
 * @param {Number} playerId - The playerId to associate a setup function with
 * @param {Function} callback - The function to be rremoved
 */
function dequeueTimeComponent(playerId, callback) {
  var queue = _timeSubscriberQueue[playerId] || (_timeSubscriberQueue.hasOwnProperty(NO_PLAYER_READY) ? _timeSubscriberQueue.NO_PLAYER_READY[playerId] : undefined) || _timeSubscriberQueue.NO_PLAYER_READY;
  if (queue) {
    if (queue.FIRST_PLAYER) {
      var index = queue.FIRST_PLAYER.indexOf(callback);
      if (index !== -1) {
        queue.FIRST_PLAYER.splice(index, 1);
      }
    } else if (Array.isArray(queue)) {
      var _index = queue.indexOf(callback);
      if (_index !== -1) {
        queue.splice(_index, 1);
      }
    }
  }
}

exports.default = {
  addPlayerInstance: addPlayerInstance,
  createReduxStore: createReduxStore,
  clearPlayerInstances: function clearPlayerInstances() {
    _playerInstances = {};
  },
  clearTimeSubscriberQueue: function clearTimeSubscriberQueue() {
    _timeSubscriberQueue = {};
  },

  setStoreInstance: setStoreInstance,
  getPlayerInstance: getPlayerInstance,
  getTimeSubscriberQueue: function getTimeSubscriberQueue() {
    return _timeSubscriberQueue;
  },
  storeInstance: function storeInstance() {
    return _storeInstance;
  },

  queueTimeComponent: queueTimeComponent,
  dequeueTimeComponent: dequeueTimeComponent,
  removePlayerInstance: removePlayerInstance,
  viActions: viActions,
  viReducers: _reducers2.default
};
module.exports = exports['default'];